export default __webpack_public_path__ + "static/media/resubmission-approved.d005fd80.svg";